<template>
    <div v-if="item && item.FatUst">
        <div class="row">
            <div class="col-md-6">
                <b-form-group label="Fatura No">
                    <b-form-input :value="item.FatUst.FATIRS_NO" readonly />
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group label="Fatura Tarihi">
                    <b-form-input :value="formatDate(item.FatUst.Tarih)" readonly />
                </b-form-group>
            </div>
            <div class="col-12">
                <b-form-group label="Cari Ünvan (Müşteri/Tedarikçi)">
                    <b-form-input :value="`${item.FatUst.CARI_UNVAN} (${item.FatUst.CariKod})`" readonly />
                </b-form-group>
            </div>
        </div>

        <hr />
        <h5>Fatura Kalemleri ({{ item.CalculatedKalemAdedi }} adet)</h5>

        <table v-if="item.Kalems && item.Kalems.length > 0" class="table table-sm table-bordered">
            <thead>
                <tr>
                    <th>Stok Kodu</th>
                    <th class="text-right">Miktar</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(kalem, index) in item.Kalems" :key="index">
                    <td>{{ kalem.STOK_KODU }}</td>
                    <td class="text-right">{{ kalem.STHAR_GCMIK }}</td>
                </tr>
            </tbody>
        </table>
        <div v-else class="alert alert-secondary" style="padding: 0.5rem">Bu faturaya ait kalem bilgisi bulunamadı.</div>
    </div>
    <div v-else class="text-center">Detay bilgisi yüklenemedi.</div>
</template>

<script>
import { BFormGroup, BFormInput } from "bootstrap-vue";

export default {
    name: "ReceiptDetailView",
    components: { BFormGroup, BFormInput },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return "-";
            return new Date(dateString).toLocaleDateString("tr-TR");
        },
    },
};
</script>
